import React, { useState, useEffect } from "react";
import styles from "./AdInvestment.module.scss";
import { getAdInvest,postAdsInvest } from "../../../apiServices";
import {formatDate,formatCurrency,MyModal } from "../../../utility"
import ModalContainer from "../../../components/modal_popup";
import SuccessTick from "../../../components/success_tick";

function AdInvestment({ openModal, setOpenModal }) {
  const [investments, setInvestments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0); 

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
    // const [openModal, setOpenModal] = useState(false);
    const [successModal, setsuccessModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
  
    const [investData, setInvestData] = useState({
      invest_date: "",
      platform: "",
      amount: "",
    });

  // Form state - what user sees in the form
  const [formFilters, setFormFilters] = useState({
    fromDate: "",
    toDate: "",
    platform: "",
  });

  // Applied filters - what actually gets used in API calls
  const [appliedFilters, setAppliedFilters] = useState({
    fromDate: "",
    toDate: "",
    platform: "",
  });

  const platforms = ["All", "Google Ads", "Meta Ads"];

  // ✅ Fetch API
  const fetchInvestments = async () => {
    setLoading(true);
    setError(null);

    try {
      const params = {
        page: currentPage,
        limit: itemsPerPage,
      };
      
      // Add applied filters only if they have values
      if (appliedFilters.fromDate) params.fromDate = appliedFilters.fromDate;
      if (appliedFilters.toDate) params.toDate = appliedFilters.toDate;
      if (appliedFilters.platform && appliedFilters.platform !== "All") {
        params.platform = appliedFilters.platform;
      }

      const response = await getAdInvest(params);

      if (response?.status) {
        setInvestments(response.data || []);
        setTotalAmount(response.totalAmount || 0);
        setTotalItems(response.pagination?.totalItems || 0);
        setTotalPages(response.pagination?.totalPages || 1); 
      } else {
        setError(response?.message || "Failed to fetch data");
        setInvestments([]);
        setTotalAmount(0);
      }
    } catch (err) {
      setError("Network error: " + err.message);
      setInvestments([]);
      setTotalAmount(0);
    } finally {
      setLoading(false);
    }
  };

     const handleChange = (e) => {
    const { name, value } = e.target;

    setInvestData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

   const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (isSubmitting) return; // prevent double click
  
    try {
      setIsSubmitting(true);
  
      const { invest_date, platform, amount } = investData;
  
      const res = await postAdsInvest({
        // adminId: adminID,  
        invest_date,
        platform,
        amount: Number(amount),
      });
  
      if (res?.status) {
        setsuccessModal(true);
  
        setTimeout(() => {
          setsuccessModal(false);
        }, 2000);
  
        setOpenModal(false);
        setInvestData({ invest_date: "", platform: "", amount: "" });
         await fetchInvestments();
      }
    } catch (error) {
      console.error("Submit error", error);
    } finally {
      setIsSubmitting(false); // ✅ ALWAYS re-enable
    }
  };


  // ✅ Auto API call - only when currentPage, itemsPerPage, or appliedFilters change
  useEffect(() => {
    fetchInvestments();
  }, [currentPage, itemsPerPage, appliedFilters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFormFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

 
  const handleFilterSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    // Only update applied filters when submit button is clicked
    setAppliedFilters(formFilters);
  };

  const handleReset = () => {
    // Reset form filters
    setFormFilters({
      fromDate: "",
      toDate: "",
      platform: "",
    });
    
    // Reset applied filters (this will trigger a new API call)
    setAppliedFilters({
      fromDate: "",
      toDate: "",
      platform: "",
    });
    
    // Reset to first page
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const getPlatformClass = (platform) => {
    const platformMap = {
      "Google Ads": "google",
      "Meta Ads": "facebook",
    };
    return platformMap[platform] || "other";
  };

  const getPaginationNumbers = () => {
    if (totalPages <= 1) {
      return [1]; 
    }
    
    const delta = 2; 
    const range = [];
    const rangeWithDots = [];
    let l;

    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - delta && i <= currentPage + delta)
      ) {
        range.push(i);
      }
    }

    range.forEach((i) => {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push("...");
        }
      }
      rangeWithDots.push(i);
      l = i;
    });

    return rangeWithDots;
  };

  return (
    <div className={styles["ad-investment"]}>
    
      <div className={styles["ad-investment__header"]}>
        <h1 className={styles["ad-investment__title"]}>
          Ad Investment Dashboard
        </h1>
      </div>

      <div className={styles["ad-investment__filters"]}>
        <form onSubmit={handleFilterSubmit} className={styles["filters-form"]}>
          <div className={styles["filters-form__group"]}>
            <label htmlFor="fromDate">From Date</label>
            <input
              type="date"
              id="fromDate"
              name="fromDate"
              value={formFilters.fromDate}
              onChange={handleFilterChange}
              className={styles["filters-form__input"]}
            />
          </div>

          <div className={styles["filters-form__group"]}>
            <label htmlFor="toDate">To Date</label>
            <input
              type="date"
              id="toDate"
              name="toDate"
              value={formFilters.toDate}
              onChange={handleFilterChange}
              className={styles["filters-form__input"]}
            />
          </div>

          <div className={styles["filters-form__group"]}>
            <label htmlFor="platform">Platform</label>
            <select
              id="platform"
              name="platform"
              value={formFilters.platform}
              onChange={handleFilterChange}
              className={styles["filters-form__input"]}
            >
              {platforms.map((platform) => (
                <option key={platform} value={platform}>
                  {platform}
                </option>
              ))}
            </select>
          </div>

          <div className={styles["filters-form__actions"]}>
            <button
              type="submit"
              className={`${styles["btn"]} ${styles["btn--primary"]}`}
            >
              <span className={styles["btn__icon"]}></span>
              Apply Filters
            </button>
            <button
              type="button"
              onClick={handleReset}
              className={`${styles["btn"]} ${styles["btn--secondary"]}`}
            >
              <span className={styles["btn__icon"]}></span>
              Reset
            </button>
          </div>
        </form>
      </div>

      <div className={styles["summary-cards"]}>
              <div className={styles["summary-card"]}>
    <div className={styles["summary-card__icon"]}>📏</div>
    <div className={styles["summary-card__content"]}>
      <h3 className={styles["summary-card__title"]}>Rows Per Page</h3>
      <div className={styles["summary-card__select"]}>
        <select
          value={itemsPerPage}
          onChange={handleItemsPerPageChange}
          className={styles["summary-card__select-input"]}
        >
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
        </select>
      </div>
    </div>
  </div>

        <div className={styles["summary-card"]}>
          <div className={styles["summary-card__icon"]}>📊</div>
          <div className={styles["summary-card__content"]}>
            <h3 className={styles["summary-card__title"]}>Total Investments</h3>
            <p className={styles["summary-card__value"]}>{totalItems}</p>
          </div>
        </div>

        <div className={styles["summary-card"]}>
          <div className={styles["summary-card__icon"]}>💰</div>
          <div className={styles["summary-card__content"]}>
            <h3 className={styles["summary-card__title"]}>Total Amount</h3>
            <p className={styles["summary-card__value"]}>
              {formatCurrency(totalAmount)} 
            </p>
          </div>
        </div>

        {/* <div className={styles["summary-card"]}>
          <div className={styles["summary-card__icon"]}>📄</div>
          <div className={styles["summary-card__content"]}>
            <h3 className={styles["summary-card__title"]}>Current Page</h3>
            <p className={styles["summary-card__value"]}>
              {currentPage} / {totalPages || 1}
            </p>
          </div>
        </div> */}
      </div>

      {error && (
        <div className={styles["error-message"]}>
          <div className={styles["error-message__icon"]}>⚠️</div>
          <div className={styles["error-message__content"]}>
            <p className={styles["error-message__text"]}>{error}</p>
            <button
              onClick={fetchInvestments}
              className={styles["error-message__retry"]}
            >
              Try Again
            </button>
          </div>
        </div>
      )}

      {loading && (
        <div className={styles["loading-spinner"]}>
          <div className={styles["loading-spinner__animation"]}></div>
          <p className={styles["loading-spinner__text"]}>
            Loading investments...
          </p>
        </div>
      )}

      {!loading && !error && (
        <div className={styles["table-container"]}>
          <div className={styles["table-container__wrapper"]}>
            <table className={styles["investment-table"]}>
              <thead className={styles["investment-table__head"]}>
                <tr>
                  <th>ID</th>
                  <th>Platform</th>
                  <th>Investment Date</th>
                  <th>Amount</th>
                  <th>Admin</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody className={styles["investment-table__body"]}>
                {investments.length > 0 ? (
                  investments.map((investment,index) => (
                    <tr
                      key={investment.id}
                      className={styles["investment-table__row"]}
                    >
                      <td
                        className={`${styles["investment-table__cell"]} ${styles["investment-table__cell--id"]}`}
                      >
                        {((currentPage - 1) * itemsPerPage) + index + 1}
                      </td>
                      <td className={styles["investment-table__cell"]}>
                        <span
                          className={`${styles["platform-badge"]} ${
                            styles[
                              `platform-badge--${getPlatformClass(
                                investment.platform
                              )}`
                            ]
                          }`}
                        >
                          {investment.platform}
                        </span>
                      </td>
                      <td className={styles["investment-table__cell"]}>
                        <div className={styles["investment-table__date"]}>
                          <span className={styles["investment-table__date-main"]}>
                            {formatDate(investment.invest_date)}
                          </span>
                        </div>
                      </td>
                      <td
                        className={`${styles["investment-table__cell"]} ${styles["investment-table__cell--amount"]}`}
                      >
                        <span className={styles["amount-value"]}>
                          {formatCurrency(investment.amount)}
                        </span>
                      </td>
                      <td className={styles["investment-table__cell"]}>
                        <div className={styles["admin-info"]}>
                          <span className={styles["admin-info__name"]}>
                            {investment.admin_name || "Unknown"}
                          </span>
                          <span className={styles["admin-info__id"]}>
                            {/* ID: {investment.by_admin} */}
                          </span>
                        </div>
                      </td>
                      <td className={styles["investment-table__cell"]}>
                        <div className={styles["investment-table__date"]}>
                          <span className={styles["investment-table__date-main"]}>
                            {formatDate(investment.created_at)}
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className={styles["investment-table__no-data"]}>
                      <div className={styles["no-data"]}>
                        <span className={styles["no-data__icon"]}>📭</span>
                        <p className={styles["no-data__text"]}>
                          No investments found matching your criteria
                        </p>
                        <button
                          onClick={handleReset}
                          className={styles["no-data__reset"]}
                        >
                          Clear Filters
                        </button>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className={styles["pagination"]}>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className={`${styles["pagination__btn"]} ${styles["pagination__btn--prev"]}`}
            >
              ← Previous
            </button>

            <div className={styles["pagination__numbers"]}>
              {getPaginationNumbers().map((pageNum, index) => {
                if (pageNum === "...") {
                  return (
                    <span key={`ellipsis-${index}`} className={styles["pagination__ellipsis"]}>
                      ...
                    </span>
                  );
                }
                return (
                  <button
                    key={pageNum}
                    onClick={() => handlePageChange(pageNum)}
                    className={`${styles["pagination__number"]} ${
                      currentPage === pageNum
                        ? styles["pagination__number--active"]
                        : ""
                    }`}
                    disabled={totalPages === 0}
                  >
                    {pageNum}
                  </button>
                );
              })}
            </div>

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages || totalPages === 0}
              className={`${styles["pagination__btn"]} ${styles["pagination__btn--next"]}`}
            >
              Next →
            </button>
          </div>
        </div>
      )}
        {openModal && (
              <MyModal>
                <ModalContainer
                  childComponent={
                    <>
                      <form onSubmit={handleSubmit}>
                        <div className="container">
                          <h5 className="mb-3">Add Ads Investment</h5>
      
                          {/* Date */}
                          <div className="mb-3">
                            <label className="form-label">Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="invest_date"
                              value={investData.invest_date}
                              onChange={handleChange}
                              required
                            />
                          </div>
      
                          {/* Platform */}
                          <div className="mb-3">
                            <label className="form-label">Platform</label>
                            <select
                              className="form-select"
                              name="platform"
                              value={investData.platform}
                              onChange={handleChange}
                              required
                            >
                              <option value="">Select Platform</option>
                              <option value="Google Ads">Google Ads</option>
                              <option value="Meta Ads">Meta Ads</option>
                            </select>
                          </div>
      
                          {/* Amount */}
                          <div className="mb-3">
                            <label className="form-label">Amount</label>
                            <input
                              type="text"
                              className="form-control"
                              name="amount"
                              placeholder="Enter amount"
                              value={investData.amount}
                              required
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                  setInvestData((prev) => ({
                                    ...prev,
                                    amount: value,
                                  }));
                                }
                              }}
                            />
                          </div>
      
                          {/* Buttons */}
                          <div className="d-flex justify-content-end gap-2">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() => setOpenModal(false)}
                              disabled={isSubmitting}
                            >
                              Cancel
                            </button>
      
                            <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                            {isSubmitting ? "Saving..." : "Save"}
                            </button>
                          </div>
                        </div>
                      </form>
                    </>
                  }
                />
              </MyModal>
            )}
            {successModal && (
              <MyModal>
                <ModalContainer
                  zIndex={1000}
                  childComponent={
                    <>
                      <SuccessTick HeadText="Successfully!" />
                    </>
                  }
                />
              </MyModal>
            )}
    </div>
  );
}

export default AdInvestment;